
import React from "react";
import "./App.scss";
import Routes from "../src/Components/routes";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "./Actions/componentActions";
import SessionHeartbeat from "./Components/CommonComponent/SessionHeartbeat";

function App() {


  const dispatch = useDispatch()

  const isSHowNotification = useSelector(state => state.componentReducer)
  const renderModal = () => {
    if (isSHowNotification.showNotification) {
      setTimeout(() => {
        dispatch(showNotification(false, "", ""))
      }, 5000)
    }
    return <div className={`notificationModal !h-[2.6rem] bg-message${isSHowNotification.type === "success" ? "-success" : "-error"}`}>
      <div className="dialog">
        <div className={`sub-modal`}>
          <h2 className={`!text-[1.4rem]`}>{isSHowNotification.message} </h2>
        </div>
      </div>
    </div>
  }
  return (
    <div className="page-sec login-bg-new dark:bg-[#121212] dark:text-[#F5F5F5]">
      <SessionHeartbeat />
      {isSHowNotification.showNotification && renderModal()}
      <Routes />
    </div>
  );
}

export default App;

